export const insufficientPointSheet = {
  title: "ポイントが不足しています",
  balanceLabel: "所持ポイント",
  neededLabelLive: "視聴に必要",
  neededLabelCall: "通話に必要",
  neededLabel: "必要",
  unitPerMin: "pt/分",
  chargeSuffix: "でチャージ",
  payNote: "アプリ内課金でお支払い",
  doneTitle: "チャージ完了！",
  doneDesc: (args: { point: string | number }) =>
    `${args.point}ptを獲得しました`,
  // 通話中・ライブ視聴中にまず表示する控えめな通知バナーの文言
  notice: {
    title: "まもなくポイントが不足します",
    subtitle: "タップしてポイントをチャージ",
    // ◯回目限定プラン（購入ボーナスコース）が有効なときだけ subtitle の上に追加する一言
    bonusSubtitle: (args: { name: string }) =>
      `${args.name}さんだけに限定のプランがあります`,
  },
  // 限定プランカードのお得ptバースト（例: 450pt お得↑）
  savingBadge: {
    amount: (args: { points: string | number }) => `${args.points}pt`,
    label: "お得↑",
  },
  // 限定プランカードの pt 横に添える小タグ
  limitedTag: "限定",
  // シーン別の増量訴求（通常比でどれだけ多くできるか）。CTA 上のピルで使用。
  // 数量部分を強調表示するため prefix / count / suffix に分割している
  gainPrefix: "通常よりも",
  // ピルの「通常」の真上に出す通常ポイント明記の吹き出し（例: 550pt）
  gainRegularBubble: (args: { points: string | number }) => `${args.points}pt`,
  scene: {
    chat: {
      gainCount: (args: { count: string | number }) => `${args.count}通`,
      gainSuffix: "も多く送れます",
    },
    video: {
      gainCount: (args: { count: string | number }) => `約${args.count}分`,
      gainSuffix: "も多く話せます",
    },
    voice: {
      gainCount: (args: { count: string | number }) => `約${args.count}分`,
      gainSuffix: "も多く話せます",
    },
    live: {
      gainCount: (args: { count: string | number }) => `約${args.count}分`,
      gainSuffix: "も多く見れます",
    },
    gift: {
      gainCount: (args: { count: string | number }) => `${args.count}個`,
      gainSuffix: "も多く送れます",
    },
    image: {
      gainCount: (args: { count: string | number }) => `${args.count}枚`,
      gainSuffix: "も多く見れます",
    },
    movie: {
      gainCount: (args: { count: string | number }) => `${args.count}本`,
      gainSuffix: "も多く見れます",
    },
    audio: {
      gainCount: (args: { count: string | number }) => `${args.count}件`,
      gainSuffix: "も多く聴けます",
    },
  },
  // Coco+ の通話中（ビデオ・音声）に残高が 1 分ぶんを切ったとき出す買い足しシート（Hiyori+ 準拠）
  callLowPoint: {
    title: "まもなく通話が終了します",
    // ライブ視聴中に出すときのタイトル
    titleLive: "まもなく視聴が終了します",
    remainingPrefix: "あと",
    remainingSuffix: "秒",
    popular: "人気No.1",
    // 人気バッジが無いときの大カードの見出し（大カードはいちばん高いプラン）
    bestValue: "いちばんおトク",
    // 大カードの値段の左隣のギザギザの吹き出し（いちばん安いプランと比べたおトク額）。2 行で出す
    savingsBubble: (args: { amount: string }) => `約${args.amount}円\nおトク！`,
    minutes: (args: { count: string | number }) => `約${args.count}分`,
    close: "閉じる",
    unavailable: "ポイントの一覧を取得できませんでした",
    buyLabel: (args: { points: string | number; price: string | number }) =>
      `${args.points}ポイント ${args.price}円で購入する`,
  },
} as const;
